import useBrand from 'hooks/useBrand';
import { TEMPO } from 'lib/constants';

const GraceCreditAndRefund = ({ total, credit, refund }) => {
  const isTempo = useBrand(TEMPO);

  return (
    <div
      className={`${isTempo ? 'border-blue-90' : 'border-green-100'} border-black mx-4 -mt-10 h-[164px] rounded-lg border-t-[5px] border-solid bg-white-100 p-4 shadow-md`}
    >
      <p className={'text-primary h1 text-3xl font-bold'}>{total.amount}</p>
      <p className={'text-sm font-medium'}>will be refunded to your payment methods</p>
      <div className={'mt-3 border-t border-solid border-t-charcoal-60 pt-1'}>
        <div className={'mt-2 grid grid-cols-3'}>
          <div className={'text-left text-sm font-medium text-charcoal-100'}>{refund.amount}</div>
          <div className={'col-span-2 text-right text-sm font-medium text-charcoal-90'}>
            Refunded to your card.
          </div>
        </div>

        <div className={'mt-2 grid grid-cols-3'}>
          <span className={'text-left text-sm font-medium text-charcoal-100'}>{credit.amount}</span>
          <span className={'col-span-2 text-right text-sm font-medium text-charcoal-90'}>
            Returned to account credits.
          </span>
        </div>
      </div>
    </div>
  );
};

GraceCreditAndRefund.propTypes = {
  total: PropTypes.exact({
    amount: PropTypes.string.isRequired,
  }),
  credit: PropTypes.exact({
    amount: PropTypes.string.isRequired,
    bodyCopy: PropTypes.string.isRequired,
  }),
  refund: PropTypes.exact({
    amount: PropTypes.string.isRequired,
    bodyCopy: PropTypes.string.isRequired,
  }),
};

export default GraceCreditAndRefund;
